/* Do not change this file. */

import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import router from "./router";
import store from "@/store";
import { $s } from "@/helpers/settings.js";
import * as datastore from "@/apis/datastore.js";
import { createPinia } from "pinia";
import { marked } from "marked";

import "bootstrap/dist/css/bootstrap.css";
//import "@osuecampus/bootstrap-osu/dist/css/bootstrap.css";

import "bootstrap-icons/font/bootstrap-icons.css";

import "@/css/style.css";

import focus from "@/directives/focus";

import CustomAlert from "@/components/ui/CustomAlert.vue";

const pinia = createPinia();

const app = createApp(App)
  .use(store)
  .use(router)
  .use(pinia)
  .directive("focus", focus);
app.component("CustomAlert", CustomAlert);

app.config.globalProperties.axios = axios;
app.config.globalProperties.$c = $s;
app.config.globalProperties.$s = $s;
app.config.globalProperties.$m = (content) => {
  return marked.parse(content);
};
app.config.globalProperties.datastore = datastore;
//app.use(MyPlugin, { /* options */ });

app.mount("#app");
